import { Cell, flexRender } from '@tanstack/react-table';
import Tooltip from 'components/tooltip/Tooltip';

interface TableBodyCellProps {
  cell: Cell<unknown, unknown>;
}

const TableBodyCell = ({ cell }: TableBodyCellProps) => {
  const cellContent = flexRender(cell.column.columnDef.cell, cell.getContext());
  const showCellTooltip = cell.column.columnDef.meta?.showCellTooltip ?? true;

  return (
    <td className={`body-cell body-cell-${cell.column.id}`}>
      {showCellTooltip ? (
        <Tooltip delay={1000} id={`tooltip-cell-${cell.id}`} text={cellContent}>
          {cellContent}
        </Tooltip>
      ) : (
        cellContent
      )}
    </td>
  );
};

export default TableBodyCell;
